import { createSelector } from 'reselect';
import { RootState } from '@src/app/_redux';
import Mylo from 'mylo-js';

export const getClientConfig = (state: RootState) => {
  return state.clientConfig;
};

export const getSocialUser = ({ auth }: RootState) => {
  return auth.socialLogin.user;
};

export const getSocialEmail = createSelector([getSocialUser], socialUser => {
  let email = '';
  if (socialUser) {
    email =
      socialUser.channel === 'google'
        ? socialUser.profileObj.email
        : socialUser.email;
  }
  return email;
});

export const getMylo = (state: RootState, redirectPath?: String) => {
  let myloConfig = state.clientConfig.clientConfig.myloConfig;
  if (redirectPath) {
    myloConfig.redirectUri = myloConfig.redirectUri.replace('/auth/login', redirectPath);
  }  
  return new Mylo(myloConfig);
};